module.exports = __webpack_public_path__ + "static/media/google.752536d8.svg";